__webpack_require__.p = "/schelling-point-bogota/";